export default __webpack_public_path__ + "static/media/wallet.3bba463e.svg";